import { useSortable } from "@dnd-kit/sortable";
import React from "react";
import { CSS } from "@dnd-kit/utilities";
import { Grid, IconButton, Typography } from "@mui/material";
import { DragIndicator, RemoveCircle } from "@mui/icons-material";
import { Base } from "../../base";

interface Props {
  site: { id?: number; value?: string; order?: number };
  removeQuestion: () => void;
}

const SortableSitePreview: React.FC<Props> = (props) => {
  const { site, removeQuestion } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    setActivatorNodeRef,
  } = useSortable({
    id: site.order!,
    data: site,
    animateLayoutChanges: () => false,
  });
  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition: transition,
        width: "100%",
      }}
    >
      <Grid key={site.order} size={12} gap={2}>
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
          <Grid>
            <IconButton
              {...attributes}
              {...listeners}
              ref={setActivatorNodeRef}
            >
              <DragIndicator />
            </IconButton>
          </Grid>
          <Grid flex={1}>
            <Typography>{site.value}</Typography>
          </Grid>
          <Grid>
            <Base.IconButton
              onClick={removeQuestion}
              label=""
              icon={<RemoveCircle />}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default SortableSitePreview;
